export const staggerContainer = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

export const panelVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: 'easeOut' },
  },
};

export const specCardVariants = {
  hidden: { opacity: 0, y: 14, scale: 0.94 },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: { duration: 0.4, ease: 'easeOut' },
  },
};

export const specRowVariants = {
  hidden: { opacity: 0, x: 0, y: -100, scale: 1.1 },
  visible: (index = 0) => ({
    opacity: 1,
    x: 0,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: [0.17, 1.87, 0.83, 1.87],
      delay: index * 0.075,
    },
  }),
};

export const viewportOnce = { once: true, amount: 0.2 };
